var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('button',{staticClass:"btn-submit",on:{"click":function($event){return _vm.$emit('submit',$event)}}},[_vm._v(" "+_vm._s(_vm.name)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }